import {MNullable} from '../../Toolkit/Utils';

export class Location {
    public lat: number = 0;
    public long: number = 0;
}

export class Address {
    public addressValid: boolean = false;
    public address1: string = '';
    public address2: string = '';
    public address3: string = '';
    public city: string = '';
    public county: string = '';
    public postcode: string = '';
}

export class LocationReply {
    public location: MNullable<Location> = null;
}

export class AddressReply{
    public address: MNullable<Address> = null;
}